import { useDispatch } from 'react-redux'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { googleAuth } from '../../features/authSlice'

export const GoogleRedirectPage = () => {
	const dispatch = useDispatch()
	const navigate = useNavigate()

	useEffect(() => {
		const params = new URLSearchParams(window.location.search)
		const code = params.get('code')
		const error = params.get('error')

		if (error) {
			navigate('/login')
			return
		}

		if (code) {
			dispatch(googleAuth(code)).then((res) => {
				if (res.meta.requestStatus === 'fulfilled') {
					navigate('/dashboard')
				} else {
					navigate('/login')
				}
			})
		} else {
			navigate('/login')
		}
	}, [dispatch, navigate])

	return <h1>Logging in with Google...</h1>
}
